import type { MailboxInfo } from "owa-client-types";
import { getIndexerValueForMailboxInfo } from "owa-client-types";
import store from "../store/store";
import type AccountScopeCategoryProperties from "../store/schema/AccountScopeCategoryProperties";

export default function getAccountCategoryProps(mailboxInfo: MailboxInfo): AccountScopeCategoryProperties | undefined {
    const key = getIndexerValueForMailboxInfo(mailboxInfo);
    const categoryProps = store().accountCategoryProps.get(key);
    return categoryProps;
}
